export default __webpack_public_path__ + "static/media/bitcoinist.e1da143d.png";